<!-- <div [ngClass]="{'showField' : showPopup, 'hideField' : !showPopup }"  [ngClass]="[showPopup ? 'showField popup-level-' + openedPopupsCount: 'popup-default']" class="FieldContainer"> -->
<link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Bitter" />
<div [ngClass]="[ (showPopup && !startHiding) ? 'showField popup-level-' + openedPopupsCount: 'hideField']"
    class="FieldContainer" [ngStyle]="{'width':popupWidth}">
    <!-- <div [ngClass]="{'showField' : (showPopup && !startHiding), 'hideField' : (startHiding || !showPopup) }" class="FieldContainer"> -->

    <div [ngClass]="{'background' : showPopup}"></div>
    <div *ngIf="showPopup">
        <div class="left-title-bar"
            [ngClass]="[showRoundedCorner ? 'round-corner': '', isActivePopup() ?  'popup-header-select' : 'popup-header-deselect']">
            <span class="vertical-text">{{"lbl_options" | translate}}</span>

        </div>
        <div class="main-modal" [ngClass]="showRoundedCorner ? 'round-corner': ''">
            <div class="header">
                <div class="head-title">
                    <div>{{"lbl_titleOption" | translate}}</div>
                </div>
                <!-- <div>{{selectedImages}}</div> -->
                <span></span>
                <!-- <div class="tabs">
    
                    </div> -->
            </div>
            <div class="body main-container">
                <div class="form-group genaration-dropdown">
                    <div *ngIf="membershipTemplate == 'AllMembershipTemplate'">

                        <div class="grid-container">
                            <div class="grid-item">
                                <div class="card">
                                    <h2>{{"lbl_basicMembership" | translate}}</h2>
                                    <p class="price">$490</p>
                                    <p>{{"lbl_basicUpgradeMessage" | translate}}</p>
                                    <p><button>
                                            <a target="_blank" href="https://shop.embla.no/home">Upgrade Now</a>
                                        </button></p>
                                </div>
                            </div>

                            <div class="grid-item">
                                <div class="card">
                                    <h2>{{"lbl_premiumMembership" | translate}}</h2>
                                    <p class="price">$890</p>
                                    <p>{{"lbl_premiumUpgradeMessage" | translate}}</p>
                                    <p><button>
                                            <a target="_blank" href="https://shop.embla.no/home">Upgrade Now</a>
                                        </button></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="membershipTemplate == 'PremiumMembershipTemplate'">
                        <div class="card">
                            <h2>{{"lbl_premiumMembership" | translate}}</h2>
                            <p class="price">$890</p>
                            <p>{{"lbl_premiumUpgradeMessage" | translate}}</p>
                            <p><button>
                                    <a target="_blank" href="https://shop.embla.no/home">Upgrade Now</a>
                                </button></p>
                        </div>
                    </div>
                </div>



                <!-- <div>
                    <ng-template appDynamicPaymentOption></ng-template>
                </div> -->

                <div class="footer">
                    <div class="buttons">                       
                        <span><button type=" button" class="btn btn-primary btn-foot btn-cancel element-over-hand"
                                (click)="cancel()">{{"lbl_cancel" | translate}}</button></span>
                    </div>
                </div>
            </div>
        </div>

    </div>